export default __webpack_public_path__ + "b62f4cb0cfd2e31ef833afbc2b6ab7ce.svg";